<template>
  <base-join-challenge :on-click="() => challengeStore.addParticipant()">
    <template v-slot:info-by-challenge-type>
      <percent-challenge-goal
        :challenge-goal="challengeStore.challengeGoal"
      />
    </template>
  </base-join-challenge>
</template>

<script lang="ts" setup>

import BaseJoinChallenge from './BaseJoinChallenge.vue';
import PercentChallengeGoal from '../ChallengeInfo/PercentChallengeGoal.vue';
import { useChallengeStore } from '../../stores/challenge';

const challengeStore = useChallengeStore();

</script>
